import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Grid,
    OutlinedInput,
    InputAdornment,
    Switch,
    ListItemSecondaryAction,
    Chip,
    Popover,
    Box,
    DialogTitle,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    Paper,
    Button
} from "@material-ui/core";
import ProfileSideBar from '../../components/ProfileSideBar/ProfileSideBar';
import * as logger from "../../../logger";
import { userManagementCss as useStyles } from './ProfileCss';
import AddIcon from '@material-ui/icons/Add';
import { UserManagementEmpty } from '../../../components/icons';
import { getMultiUserList } from '../../../store/actions/userActionCreators';
import SearchIcon from '@material-ui/icons/Search';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import MUIDataTable from "mui-datatables";
import MuiltiUserAddUserDialog from '../../components/Dialog/MultiUserAddUser';
import MultiUserInviteSuccess from '../../components/Dialog/MultiUserInviteSuccessDialog';
import { editUserStatus } from '../../../store/actions/userActionCreators';
import { trackDwebEvent } from '../../analytics';
import EditIcon from '@material-ui/icons/Edit';
const UserManagement = ({ user, dispatchGetMultiUserList, dispatchEditUserStatus }) => {

    const [multiUserList, setMultiUserList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [multiUserAddOpen, setMultiUserAddOpen] = useState(false);
    const [recall, setRecall] = useState(false);
    const [addUserInfo, setAddUserInfo] = useState({});
    const [inviteSuccess, setInviteSuccess] = useState(false);
    const [displayPage, setDisplayPage] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editUser, setEditUser] = useState(false);



    const classes = useStyles();

    useEffect(() => {
        trackDwebEvent("Dweb User Management Page", {});
    }, []);

    useEffect(() => {

        dispatchGetMultiUserList(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('User Management Dweb', "Get Multi User List Successfull");
                    setDisplayPage(true);
                }
            },
            () => {
                logger.log('User Management Dweb', "Get Multi User List Failed");
            }
        )

    }, [recall]);

    useEffect(() => {

        const multiUserData = user && user.multiUserList && user.multiUserList.length > 0 ? (user.multiUserList).slice() : [];

        if (user && user.multiUserList && user.multiUserList.length > 0) {

            const currentUserNumber = user && user.userInfoProfile && user.userInfoProfile.contactNumber ? user.userInfoProfile.contactNumber : ""

            if (currentUserNumber) {

                const targetIndex = user.multiUserList.findIndex((item) => item.contact_number == currentUserNumber);

                if (targetIndex != -1) {
                    multiUserData.splice(targetIndex, 1);
                }

                setMultiUserList(multiUserData);

            }
        }

    }, [user.multiUserList, user.userInfoProfile]);

    const muiColumns = [
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "contact_number",
            label: "Phone Number",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                            <div style={{width:120}}>
                                {muiData && muiData[dataIndex] && muiData[dataIndex].contact_number ? "+91 " + muiData[dataIndex].contact_number : ""}
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: "role",
            label: "Role",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                            {muiData && muiData[dataIndex] && muiData[dataIndex].role == "ADMIN" && <div>Admin</div>}
                            {muiData && muiData[dataIndex] && muiData[dataIndex].role == "USER" && <div>User</div>}
                        </>
                    )
                }
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = muiData && muiData[dataIndex] ? muiData[dataIndex] : {};
                    return (
                        <>
                            {rowData && rowData.status === "ACTIVE" && <div>Active</div>}
                            {rowData && rowData.status === "INACTIVE" && <div>Invite Cancelled</div>}
                            {rowData && rowData.status === "REVOKE" && <div>Inactive</div>}
                            {rowData && rowData.status === "ACCEPTANCE_PENDING" && <div>Invited</div>}
                        </>
                    )
                }
            },
        },
        {
            name: "action",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                empty: false,
                download: false,
                searchable: false,
                viewColumns: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = muiData && muiData[dataIndex] ? muiData[dataIndex] : {};
                    return (
                        <div style={{width:132}}>
                            {rowData && rowData.status === "ACTIVE" && <div><Button variant="outlined" className={classes.buttonInactive} onClick={() => handleActionClick(muiData[dataIndex])}>Make Inactive</Button></div>}
                            {rowData && rowData.status === "INACTIVE" && <div><Button variant="outlined" className={classes.buttonActive} onClick={() => handleActionClick(muiData[dataIndex])}>Invite Again</Button></div>}
                            {rowData && rowData.status === "REVOKE" && <div><Button variant="outlined" className={classes.buttonMakeActive} onClick={() => handleActionClick(muiData[dataIndex])} >Make Active</Button></div>}
                            {rowData && rowData.status ==="ACCEPTANCE_PENDING" && <div><Button variant="outlined" className={classes.buttonCancelActive} onClick={() => handleActionClick(muiData[dataIndex])} >Cancel Invite</Button></div>}
                        </div>
                    )
                }
            },
        },
        {
            name: "action",
            label: "Khata Permission",
            options: {
                filter: false,
                sort: false,
                empty: false,
                download: false,
                searchable: false,
                viewColumns: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = muiData && muiData[dataIndex] ? muiData[dataIndex] : {};
                    return (
                        <>
                            <div><Button variant="contained" disabled={rowData && rowData.status === "ACTIVE"?false:true} className={classes.edit} onClick={(e) => handleUserEdit(e,muiData[dataIndex])}>Edit <EditIcon fontSize={'inherit'} /></Button></div>
                        </>
                    )
                }
            },
        }
    ];
    const muiData = multiUserList;
    const options = {
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparkline,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
            //   goToPartyView(muiData[rowMeta.dataIndex])
        },
        customToolbar: (data) => {
            return <>

            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            // value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search User',
        onSearchChange: (searchText) => {
            setSearchText(searchText ? !searchText.replace(/\s/g, '').length ? searchText.trim() : searchText : "");
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            if (searchQuery && searchQuery.trim().length > 0) {
                searchQuery = searchQuery.trim()
                currentRow.forEach(col => {
                    if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
                        isFound = true;
                    }
                });
            } else {
                isFound = true;
            }
            return isFound;
        },
        textLabels: {
            body: {
                noMatch: "Sorry, no Users found",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const handleAddUser = () => {
        setMultiUserAddOpen(true);
    }

    const handleMultiUserAddClose = () => {
        setMultiUserAddOpen(false);
    }
    const handleMultiUserEditClose = () => {
        setEditUser(false);
    }

    const handleMultiUserAddSave = (value) => {
        setAddUserInfo(value);
        setInviteSuccess(true);
        setMultiUserAddOpen(false);
        setRecall(!recall);
    }
    const handleMultiUserEditSave = (value) => {
        setEditData(null);
        setEditUser(false);
        setRecall(!recall);
    }

    const handleMultiUserInviteSuccessClose = () => {
        setInviteSuccess(false);
    }

    const handleUserEdit = (e,data) =>{
        trackDwebEvent('Dweb User Management Edit Permission clicked')
        e.preventDefault();
        setEditData(data);
        setEditUser(true)
    }
    const handleActionClick = (userData) => {

        const status = userData.status;
        let statusValue;

        if (status === "ACTIVE") {
            statusValue = "REVOKE"
        } else if (status === "INACTIVE") {
            statusValue = "ACCEPTANCE_PENDING"
        } else if (status === "ACCEPTANCE_PENDING") {
            statusValue = "INACTIVE"
        } else if (status === "REVOKE") {
            statusValue = "ACTIVE"
        }

        const userStatus = {
            userId: userData && userData.id ? userData.id : "",
            status: statusValue,
            userOrgId: userData && userData.user_org_id ? userData.user_org_id : ""
        }

        dispatchEditUserStatus(userStatus,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('User Management Dweb', 'Edit user status successfull');
                    if (status == "ACTIVE") {
                        trackDwebEvent("Dweb User Management Make InActive", {
                            invited_user_name: userData && userData.name ? userData.name : "",
                            invited_user_contact_number: userData && userData.contact_number ? userData.contact_number : "",
                            invited_user_id: userData && userData.user_org_id ? userData.user_org_id : "",
                            invited_user_status: userData && userData.status ? userData.status : ""
                        })
                    } else if (status == "INACTIVE") {
                        trackDwebEvent("Dweb User Management Invtite Again", {
                            invited_user_name: userData && userData.name ? userData.name : "",
                            invited_user_contact_number: userData && userData.contact_number ? userData.contact_number : "",
                            invited_user_id: userData && userData.user_org_id ? userData.user_org_id : "",
                            invited_user_status: userData && userData.status ? userData.status : ""
                        })
                    } else if (status == "ACCEPTANCE_PENDING") {
                        trackDwebEvent("Dweb User Management Cancel Active", {
                            invited_user_name: userData && userData.name ? userData.name : "",
                            invited_user_contact_number: userData && userData.contact_number ? userData.contact_number : "",
                            invited_user_id: userData && userData.user_org_id ? userData.user_org_id : "",
                            invited_user_status: userData && userData.status ? userData.status : ""
                        })
                    } else if (status == "REVOKE") {
                        trackDwebEvent("Dweb User Management Make Active", {
                            invited_user_name: userData && userData.name ? userData.name : "",
                            invited_user_contact_number: userData && userData.contact_number ? userData.contact_number : "",
                            invited_user_id: userData && userData.user_org_id ? userData.user_org_id : "",
                            invited_user_status: userData && userData.status ? userData.status : ""
                        })
                    }

                    setRecall(!recall);
                }
            },
            () => {
                logger.log('User Management Dweb', 'Edit user status failed');
            }
        );

    }

    return (
        <>
            <Grid container direction="row" style={{ flexWrap: 'nowrap' }}>
                <Grid item style={{ height: '100%' }} >
                    <ProfileSideBar />
                </Grid>

                <Grid item className={classes.gridV1}>
                    <Paper className={classes.paperV1} >
                        {displayPage &&
                            <>
                                {multiUserList && multiUserList.length == 0 &&
                                    <div className={classes.divAlign} >
                                        <div>
                                            <UserManagementEmpty className={classes.userManagementEmpty} />
                                        </div>
                                        <div className={classes.divV3}>
                                            <div className={classes.divV1} >User Management</div>
                                            <div className={classes.divV2}>Click “+ Add User” to add user to</div>
                                        </div>
                                        <div className={classes.mtV1}>
                                            <Button
                                                className={classes.addButton}
                                                startIcon={<AddIcon />}
                                                onClick={() => handleAddUser()}
                                            >
                                                Add User
                                            </Button>
                                        </div>
                                    </div>
                                }

                                {multiUserList && multiUserList.length > 0 &&
                                    <div className={classes.divTable}>
                                        <div className={classes.divV4} >User listing</div>

                                        <div className={classes.mtV2} >
                                            <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Paper>
                </Grid>
            </Grid>

            {multiUserAddOpen &&
                <MuiltiUserAddUserDialog open={multiUserAddOpen} onClose={handleMultiUserAddClose} onSave={handleMultiUserAddSave} />
            }
            {editUser &&
                <MuiltiUserAddUserDialog edit={true} editData={editData} open={editUser} onClose={handleMultiUserEditClose} onSave={handleMultiUserEditSave} />
            }
            {inviteSuccess &&
                <MultiUserInviteSuccess open={inviteSuccess} userData={addUserInfo} onClose={handleMultiUserInviteSuccessClose} />
            }
        </>
    );
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetMultiUserList: (onSuccess, onError) => {
        dispatch(getMultiUserList(onSuccess, onError))
    },
    dispatchEditUserStatus: (data, onSuccess, onError) => {
        dispatch(editUserStatus(data, onSuccess, onError))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
